import { Button } from '@material-ui/core'
import { on } from 'process'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'

interface TaskPageHeaderActionsProps {
  activeUserIsAlreadyAssigned: boolean
  assignedActiveUser: boolean
  onAssignUserClick: () => void
  onSaveClick: () => void
  onBackButtonClick: () => void
}

export const TaskPageHeaderActions: React.FC<TaskPageHeaderActionsProps> = ({
  activeUserIsAlreadyAssigned,
  assignedActiveUser,
  onAssignUserClick,
  onSaveClick,
  onBackButtonClick
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'tasks', 'enums'])
  const history = useHistory()

  // #region Handlers Starts
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <>
      <Button variant="text" color="primary" size="small" onClick={onBackButtonClick}>
        {t('tasks:editTask.actions.back')}
      </Button>
      <Button
        variant="text"
        color="primary"
        size="small"
        disabled={activeUserIsAlreadyAssigned || assignedActiveUser}
        onClick={onAssignUserClick}
      >
        {t('tasks:editTask.actions.assign')}
      </Button>
      {/* <Button variant="text" color="primary" size="small" onClick={onViewTaskActionsClick}>
        {t('tasks:editTask.actions.viewTaskActions')}
      </Button> */}
      <Button variant="contained" color="primary" size="small" onClick={onSaveClick}>
        {t('tasks:editTask.actions.save')}
      </Button>
    </>
  )
}
